/* ─── RootFusion SA — Global Theme JS ───────────────────────── */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile nav toggle ── */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
  }

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── Fade-in on scroll ── */
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-up').forEach(function (el) { observer.observe(el); });

  /* ── Variant selector ── */
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const form = this.closest('form');
      if (!form) return;
      form.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      const variantId = this.dataset.variantId;
      const input = form.querySelector('[name="id"]');
      if (input) input.value = variantId;
      /* Update price display */
      const price = this.dataset.price;
      const comparePrice = this.dataset.comparePrice;
      const priceEl = document.querySelector('.product-main-price');
      const comparePriceEl = document.querySelector('.product-compare-price');
      if (priceEl && price) priceEl.textContent = price;
      if (comparePriceEl) {
        comparePriceEl.textContent = comparePrice || '';
        comparePriceEl.style.display = comparePrice ? 'inline' : 'none';
      }
      /* Update available state */
      const available = this.dataset.available === 'true';
      const addBtn = form.querySelector('.add-to-cart-btn');
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  });

  /* ── Add to cart feedback ── */
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const btn = form.querySelector('.add-to-cart-btn');
      if (!btn) return;
      const original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      setTimeout(function () {
        btn.textContent = '✓ Added!';
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      }, 600);
    });
  });

});
